import { render, staticRenderFns } from "./EditAssignAgentGroupToProject.vue?vue&type=template&id=2306c6ae&scoped=true"
import script from "./EditAssignAgentGroupToProject.vue?vue&type=script&lang=js"
export * from "./EditAssignAgentGroupToProject.vue?vue&type=script&lang=js"
import style0 from "./EditAssignAgentGroupToProject.vue?vue&type=style&index=0&id=2306c6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2306c6ae",
  null
  
)

export default component.exports